<!-- IIT2-5800 Starts-->
<div class="d-flex flex-column h-100" id="deviceAutoShutDown">
    <div class="right_section_header" id="rightSectionHeader">
        <span class="auto_shutdown_icon"></span>
        <span i18n="@@device-dashboard.auto-heading.auto-shutdown">AUTO-SHUTDOWN</span>
    </div>
    <div class="right_section_body auto_shutdown_tab" id="autoShutDownTab">
        
        <div class="mt-2" id="autoShutDownTitle">
            <span>{{deviceConst.AUTO_SHUTDOWN_TITLE}}</span>
        </div>
        <form class="form-inline">
            <div class="form-check" id="autoShutDownEnable">
                <input class="form-check-input" type="radio" [checked]="autoShutdownEnable" [value]="autoShutdownEnable"
                    (change)="shutDownCheck($event,'autoShutdownEnable')" name="enableshutdown" id="enable" />
                <label class="form-check-label" for="enable"><span i18n="@@device-dashboard.auto-enable.enable">Enable</span></label>
            </div>
            <div class="form-check disable-check" id="autoShutDownDisable">
                <input class="form-check-input" type="radio" [checked]="autoShutdownDisable"
                    [value]="autoShutdownDisable" name="disableShutdown" id="disable"
                    (change)="shutDownCheck($event,'autoShutdownDisable')" />
                <label class="form-check-label" for="disable"><span i18n="@@device-dashboard.auto-disable.disable">Disable</span></label>
            </div>
        </form>
        <div *ngIf="autoShutdownEnable" class="time_block" id="shutDownTimeBlock">
            <div class="timezone" id="timeZone">
                <div id="shoutDownHours"><span i18n="@@device-info.hours-label">Hours</span></div>
                <div id="shoutDownMinutes"><span i18n="@@retail-hq.minutes">Minutes</span></div>
            </div>
            <iposcen-date-time-zone (isTimeZoneSelected)="checkTimeZone($event)"
                (defualtTimeZone)="getDefaultTimeZone($event)" [publishDateInfo]="editPublishDateInfo"
                (getDateTimeZoneData)="getTimeTimeZoneData($event)" [hideCalendar]="true"></iposcen-date-time-zone>
                <div *ngIf="!isSettingsTimeZoneSelected" class="formfield_err_msg" id="isSettingTimeZoneSelected">
                    <span class="timezone_error"><span i18n="@@device-dashboard.please-select-timezone.please-select-timezone">Please Select Time zone.</span></span>
                  </div>
            </div>
    </div>
    <div class="button_wrapper justify-content-end" id="shoutDownButtons">
        <button type="button" class="btn btn-outline-primary btn-lg" data-dismiss="modal" (click)='cancel()'>
            {{cancelBtn}}
        </button>
        <button type="button" (click)="sendDataToStore()" class="btn btn-primary btn-lg gtmEditDeviceSavePromoContent">
            <span i18n="@@device-banner-carousel.button.save-changes">Save Changes</span>
        </button>
    </div>
</div>
<!-- remove-popup-message -->
<div class="container" id="removePopupMessageContainer">
    <div class="modal-dialog-centered" *ngIf="openModalPopup" id="removePopupMessageModal">
        <div class="modal-backdrop show" id="removePopupMessageModalBackDrop"></div>
        <div class="modal" id="myModal">
            <div class="modal-dialog" id="myModalDialog">
                <div class="modal-content" id="myModalContent">
                    <div class="close" (click)="closeModal()" id="modalClose">
                        <img alt="close" class="modal-close-icon">
                    </div>
                    <div class="modal-body" [ngClass]="{'modal-body-cancel': isCancel}" id="modalBody">
                        <div *ngIf='!isCancel' class="action_on_pending_user" id="actionOnPendingUser">
                            <span class="success_img"></span>
                        </div>
                        <div class="action-success-msg" id="actionSuccessMsg">
                            <span>{{successMessage}}</span>
                        </div>
                        <div class="card_desc" id="cardDesc">
                            <span>{{description}}</span>
                        </div>
                    </div>
                    <div *ngIf='isCancel' class='modal-footer' id="modalFooterBtnLabel">
                        <button class='btn btn-outline-primary btn-lg' (click)="closeModal()">{{buttonLabelNo}}</button>
                        <button class='btn btn-primary btn-lg' (click)='dismiss()'>{{buttonLabelCancel}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- IIT2-5800 ends-->